<template>
  <div>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="createBookingDialog" max-width="800px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title class="grey--text align-center"
            >Create new booking</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCreateBooking">
            <v-alert :value="flueVaccineMessage" type="error">{{
              fluVaccineQuestions.message
            }}</v-alert>
            <div v-if="steps.fluQuestions.active">
              <v-col cols="12" md="12">
                <p v-for="flu in fluVaccineQuestions.questions" :key="flu.id">
                  {{ flu.question }}
                  <v-radio-group
                    :mandatory="false"
                    v-model="customField[flu.id]"
                    :rules="[rules.required]"
                    row
                  >
                    <v-radio
                      v-for="option in flu.options"
                      :key="option.id"
                      :label="option.option"
                      :value="option.option"
                    ></v-radio>
                  </v-radio-group>
                </p>
                <v-divider></v-divider>
              </v-col>
            </div>
            <div v-if="steps.covidQuestions.active">
              <v-alert :value="covidMessage" type="error">{{
                covidQuestions.message
              }}</v-alert>
              <v-col cols="12" md="12">
                <p class="h1">
                  <b>{{ covidQuestions.disclaimer }}</b>
                </p>
                <p v-for="covid in covidQuestions.questions" :key="covid.id">
                  {{ covid.question }}
                  <v-radio-group
                    :mandatory="false"
                    v-model="customField[covid.id]"
                    :rules="[rules.required]"
                    row
                  >
                    <v-radio
                      v-for="option in covid.options"
                      :key="option.id"
                      :label="option.option"
                      :value="option.option"
                    ></v-radio>
                  </v-radio-group>
                </p>
                <v-divider></v-divider>
              </v-col>
            </div>

            <v-row>
              <v-col cols="12" md="6">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >person</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.firstname"
                  label="First name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  filled
                  v-model="booking.lastname"
                  :rules="[rules.required]"
                  label="Last name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >email</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.email"
                  :rules="[rules.email, rules.required]"
                  label="Email"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >email</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.confirmEmail"
                  :rules="[rules.confirmEmail, rules.required]"
                  label="Confirm email"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >settings_cell</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.mobile"
                  label="Mobile number"
                  hint="for SMS confirmation"
                  v-mask="'###########'"
                  persistent-hint
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class>
              <v-col cols="12" md="4" class>
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >mdi-calendar</v-icon
                >
                <v-select
                  filled
                  v-model="booking.dobDay"
                  v-if="(booking.type = 'SLOT')"
                  label="Date of birth (day)"
                  hint="01 - 31"
                  :persistent-hint="true"
                  :items="days"
                  :menu-props="{ maxHeight: '800', top: true, offsetY: true }"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" class>
                <v-select
                  filled
                  v-model="booking.dobMonth"
                  v-if="(booking.type = 'SLOT')"
                  label="Date of birth (month)"
                  hint="January - December"
                  :persistent-hint="true"
                  :items="months"
                  :menu-props="{ maxHeight: '800', top: true, offsetY: true }"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" class>
                <v-select
                  filled
                  v-model="booking.dobYear"
                  v-if="(booking.type = 'SLOT')"
                  label="Date of birth (year)"
                  hint="Date of birth (year)"
                  :persistent-hint="true"
                  :items="rangeOfYears"
                  :menu-props="{ maxHeight: '800', top: true, offsetY: true }"
                ></v-select>
              </v-col>
            </v-row>

            <div
              v-for="collectUserData in this.collectUserDatas"
              :key="collectUserData.id"
            >
              <v-row v-if="collectUserData.questionType !== 'PREQUESTION'">
                <v-col cols="12" md="12">
                  <v-icon
                    class="float-left py-4 pr-2"
                    v-if="collectUserData.fieldType !== 'checkbox'"
                    color="primary"
                    >mdi-pencil</v-icon
                  >
                  <v-text-field
                    class="hint"
                    persistent-hint
                    :hint="collectUserData.hint"
                    v-model="customField[collectUserData.fieldName]"
                    v-if="collectUserData.fieldType === 'text'"
                    filled
                    :rules="collectUserData.validation"
                    :label="collectUserData.label"
                    required
                  ></v-text-field>
                  <v-select
                    class="hint"
                    persistent-hint
                    :hint="collectUserData.hint"
                    v-model="customField[collectUserData.fieldName]"
                    v-if="collectUserData.fieldType === 'select'"
                    filled
                    :rules="collectUserData.validation"
                    :label="collectUserData.label"
                    :items="collectUserData.options"
                    required
                  ></v-select>
                  <v-checkbox
                    class="hint"
                    persistent-hint
                    :rules="collectUserData.validation"
                    :hint="collectUserData.hint"
                    v-model="customField[collectUserData.fieldName]"
                    v-if="collectUserData.fieldType === 'checkbox'"
                    :label="collectUserData.label"
                    value="true"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>

            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                color="blue darken-1"
                text
                @click="createBookingDialog = false"
                class="hp--btn"
                >Close</v-btn
              >

              <v-spacer></v-spacer>
              <v-btn
                depressed
                color="blue darken-1"
                @click="createBooking()"
                text
                class="hp--btn"
                :loading="createBookingLoader"
                >Save</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-for="event in events" :key="event.id" style="margin-bottom: 15px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            {{ event.date | moment("Do MMMM YYYY") }},
            {{ event.room | capitalize }}
            <span class="grey--text"
              >({{ event.bookedCount }}/{{ event.slotCount }})</span
            >
            - {{ event.town }}
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-chip color="grey lighten-1" small>{{ event.code }}</v-chip>
          <v-chip
            v-if="event.status === 'Live'"
            class="ma-1"
            color="green darken-1"
            label
            small
            text-color="white"
            width="200"
          >
            <v-icon left small>mdi-play</v-icon>LIVE
          </v-chip>
          <v-chip
            v-if="event.status === 'Paused'"
            class="ma-1"
            color="blue"
            label
            small
            text-color="white"
            width="200"
          >
            <v-icon left small>mdi-pause</v-icon>PAUSED
          </v-chip>
          <v-chip
            v-if="event.status === 'Draft'"
            class="ma-1"
            color="orange"
            label
            small
            text-color="white"
            width="200"
          >
            <v-icon left small>mdi-pencil</v-icon>DRAFT
          </v-chip>
          <v-chip color="blue darken-2" class="white--text" label small>{{
            event.type | capitalize
          }}</v-chip>

          <v-menu left bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" class="hp--btn">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="csvDownloadAll(events)">
                <v-list-item-title>CSV (ALL)</v-list-item-title>
              </v-list-item>
              <v-list-item @click="csvDownload(event.slot)">
                <v-list-item-title>CSV (SLOT)</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>

        <v-divider></v-divider>
        <v-data-table
          :items="event.slot"
          :headers="slotHeader"
          class="elevation-1"
          :sort-by="['time']"
          :sort-desc="[false]"
          :items-per-page="-1"
        >
          <template v-slot:item.attendance="{ item }">
            <v-checkbox
              @click="markAttendance(item)"
              v-model="item.attendance"
              hide-details
              class="shrink mt-0"
              :disabled="!item.booked || !event.attendance"
              v-if="item.type !== 'BREAK'"
              color="blue"
            ></v-checkbox>
          </template>
          <template v-slot:item.name="{ item }"
            >{{ item.firstname | capitalize }}
            {{ item.lastname | capitalize }}</template
          >
          <template v-slot:item.email="{ item }">
            <b v-if="item.type === 'BREAK' || item.type === 'BLOOD'">
              <span>{{ item.type }}</span>
            </b>
            <span v-else>{{ item.email }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom v-if="item.type === 'SLOT'">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="success"
                  @click="onCreateBooking(item, event)"
                  >edit</v-icon
                >
              </template>
              <span>Create appointment</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.type === 'SLOT'">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="info"
                  :disabled="item.cancelBooking"
                  @click="resendEmail(item)"
                  >send</v-icon
                >
              </template>
              <span>Resend Email</span>
            </v-tooltip>

            <v-tooltip bottom v-if="item.type === 'SLOT'">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="cancelBooking(item)"
                  :disabled="item.cancelBooking"
                  color="error"
                  >delete</v-icon
                >
              </template>
              <span>Cancel appointment</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { Booking } from "../classes/Booking";
import * as mutations from "./../graphql/mutations";
import * as PreQuestions from "../classes/PreQuestions";
import moment from "moment";
export default {
  props: {
    events: Array,
  },
  data() {
    return {
      booking: [],
      collectUserDatas: [],
      customField: {},
      createBookingDialog: false,
      createBookingLoader: false,
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
      },
      rules: {
        required: (v) => !!v || "This field is required.",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        confirmEmail: (v) =>
          v === this.booking.email || "Confirmation email must match email",
      },
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      months: [
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      slotHeader: [
        { value: "attendance", align: "left", sortable: false, width: "25px" },
        { text: "Time", value: "time", align: "left" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Contact", value: "mobile" },
        { text: "DOB", value: "dob" },
        { text: "Reminder", value: "twentyFourHourReminder" },
        { value: "action", align: "right", sortable: false, width: "120px" },
      ],
      steps: {
        fluQuestions: { active: false },
        covidQuestions: { active: false },
      },
      fluVaccineQuestions: {},
      flueVaccineMessage: false,
      covidQuestions: {},
      covidMessage: false,
    };
  },
  methods: {
    async onCreateBooking(slot, ev) {
      this.createBookingDialog = true;
      this.booking = {
        id: slot.id,
        slotId: slot.slotId,
        time: slot.time,
        type: slot.type,
        firstname: slot.firstname,
        lastname: slot.lastname,
        email: slot.email,
        confirmEmail: slot.email,
        mobile: slot.mobile,
        dobDay: slot.dob ? moment(slot.dob, "DD/MM/YYYY").format("DD") : null,
        dobMonth: slot.dob ? moment(slot.dob, "DD/MM/YYYY").format("MM") : null,
        dobYear: slot.dob ? moment(slot.dob, "DD/MM/YYYY").format("YYYY") : null
      };
      const event = await Booking.getEvent(ev.code.toLowerCase());

      // Custom fields
      this.collectUserDatas = Booking.customFields(event[0]);

      // Flu Vaccine
      this.fluVaccineQuestions = PreQuestions.fluQuestions;

      // Covid Questions
      this.covidQuestions = PreQuestions.covidQuestions;

      // Booking steps
      this.steps = Booking.bookingSteps(
        this.collectUserDatas,
        event[0].preQuestionTemplate
      );

      if (slot.customData) {
        let customData = JSON.parse(slot.customData);
        let key = Object.keys(customData)[0];
        let value = customData[Object.keys(customData)[0]];
        this.customField[key] = value;
      }
    },
    async createBooking() {
      const that = this;
      if (this.steps.fluQuestions.active) {
        let valid = true;
        this.fluVaccineQuestions.questions.forEach(function (vaccine) {
          if (vaccine.success !== that.customField[vaccine.id]) {
            valid = false;
          }
        });
        if (valid) {
          this.flueVaccineMessage = false;
        } else {
          this.flueVaccineMessage = true;
          return false;
        }
      }

      if (this.steps.covidQuestions.active) {
        let valid = true;
        this.covidQuestions.questions.forEach(function (covid) {
          if (covid.success !== that.customField[covid.id]) {
            valid = false;
          }
        });
        if (valid) {
          this.covidMessage = false;
          this.$emit("toParent", this.customField, this.step + 1);
        } else {
          this.covidMessage = true;
          return false;
        }
      }

      if (this.$refs.formCreateBooking.validate()) {
        this.createBookingLoader = true;
        this.events.map((event, eventIndex) => {
          event.slot.map(async (slot, slotIndex) => {
            if (that.booking.slotId === slot.slotId) {
              let booking = [];
              if (that.booking.id === null) {
                booking = await Booking.createBookingAuthenticated({
                  firstname: this.booking.firstname,
                  lastname: this.booking.lastname,
                  email: this.booking.email,
                  mobile: this.booking.mobile,
                  dob:
                    that.booking.dobDay +
                    "/" +
                    that.booking.dobMonth +
                    "/" +
                    that.booking.dobYear,
                  customData: this.customField,
                  isDeleted: 0,
                  startTime: moment(
                    moment(event.date).format("YYYY-MM-DD") +
                      " " +
                      that.booking.time.substring(0, 5)
                  ),
                  eventBookingEventSlotId: that.booking.slotId,
                  marketing: false,
                  marketingEmail: false,
                  marketingText: false
                });

                /* NOTIFY USER OF BOOKING */
                await Booking.sendBookingEmail({
                  slotTime: booking.eventSlot.time,
                  eventDate: booking.eventSlotGroup.date,
                  company: booking.eventCompany.name,
                  event: booking.event.name,
                  room: booking.eventSlotGroup.room,
                  firstname: booking.firstname,
                  lastname: booking.lastname,
                  email: booking.email,
                  phone: booking.mobile,
                  iCalendar: booking.event.iCalendar,
                  bloodDropStart: booking.event.bloodDropStart,
                  bloodDropEnd: booking.event.bloodDropEnd,
                  urinePotLocation: booking.event.urinePotLocation,
                  commsLink: booking.event.commsLink,
                  commsTemplateId: booking.event.commsTemplate,
                });

                Booking.sendTextMessage({
                  slotTime: booking.eventSlot.time,
                  mobile: booking.mobile,
                  event: booking.event.name,
                  eventDate: booking.eventSlotGroup.date,
                  firstname: booking.firstname,
                  lastname: booking.lastname,
                  room: booking.eventSlotGroup.room,
                  commsTemplateId: booking.event.commsTemplate,
                });

                // Slot counts
                slot.id = booking.id;
                slot.firstname = booking.firstname;
                slot.lastname = booking.lastname;
                slot.mobile = booking.mobile;
                slot.email = booking.email;
                slot.booked = 1;
                slot.dob =
                  this.booking.dobDay +
                  "/" +
                  this.booking.dobMonth +
                  "/" +
                  this.booking.dobYear;
                // company.bookedCount++;
                // company.slotCount++;
                event.bookedCount++;
                event.slotCount++;

                this.showSuccessMessage(
                  `${booking.firstname} ${booking.lastname} slot created`
                );
              } else {
                if (that.booking.slotId === slot.slotId) {
                  booking = await Booking.updateBooking({
                    id: this.booking.id,
                    firstname: this.booking.firstname,
                    lastname: this.booking.lastname,
                    email: this.booking.email,
                    mobile: this.booking.mobile,
                    dob:
                      this.booking.dobDay +
                      "/" +
                      this.booking.dobMonth +
                      "/" +
                      this.booking.dobYear,
                    isDeleted: 0,
                    eventBookingEventSlotId: this.booking.slotId,
                    cancelBooking: true
                  });

                  this.showSuccessMessage(
                    `${booking.firstname} ${booking.lastname} slot updated`
                  );
                }
              }
              // Update table slot
              slot.id = booking.id;
              slot.firstname = booking.firstname;
              slot.lastname = booking.lastname;
              slot.mobile = booking.mobile;
              slot.email = booking.email;
              slot.booked = 1;
              slot.dob = this.booking.dobDay
                ? this.booking.dobDay +
                  "/" +
                  this.booking.dobMonth +
                  "/" +
                  this.booking.dobYear
                : null;
              slot.booked++;
              slot.cancelBooking = false;
              this.createBookingLoader = false;
              this.createBookingDialog = false;
            }
          });
        });
      }
    },
    async cancelBooking(booking) {
      const confirmCancellation = confirm(
        "Are you sure you want to cancel this appointment?"
      );

      if (confirmCancellation) {
        this.events.map((event, eventIndex) => {
          event.slot.map(async (slot, slotIndex) => {
            if (booking.slotId === slot.slotId) {
              await Booking.cancelBooking({
                bookingId: booking.id,
                slotId: booking.slotId,
                iCalendar: event.iCalendar,
                type: booking.type,
                email: booking.email,
                firstname: booking.firstname,
                room: event.room,
                time: booking.time,
                date: moment(event.date).format("YYYY-MM-DD"),
                company: event.company,
                event: event.name,
                booked: event.booked
              });
              //   company.bookedCount--;
              //   company.slotCount--;
              event.bookedCount--;
              event.slotCount--;
              slot.name = "";
              slot.cancelBooking = true;
              slot.id = null;
              slot.firstname = "";
              slot.lastname = "";
              slot.mobile = "";
              slot.email = "";
              slot.booked = 0;
              slot.dob = "";
            }
          });
        });
      }
    },
    async resendEmail(booking) {
      const that = this;
      const confirmResendEmail = confirm(
        "Are you sure you want to resend email?"
      );

      if (confirmResendEmail) {
        this.events.map((event, eventIndex) => {
          event.slot.map(async (slot, slotIndex) => {
            if (booking.slotId === slot.slotId) {
              booking = await Booking.updateBooking({
                id: booking.id,
                firstname: booking.firstname,
                lastname: booking.lastname,
                email: booking.email,
                mobile: booking.mobile,
                dob: booking.dob,
                isDeleted: 0,
                eventBookingEventSlotId: booking.slotId,
                cancelBooking: true,
              });

              await Booking.sendBookingEmail({
                slotTime: booking.eventSlot.time,
                eventDate: booking.eventSlotGroup.date,
                company: booking.company,
                event: booking.event,
                room: booking.eventSlotGroup.room,
                firstname: booking.firstname,
                lastname: booking.lastname,
                email: booking.email,
                phone: booking.mobile,
                iCalendar: event.iCalendar,
                commsTemplateId: booking.commsTemplateId,
              });
            }
          });
        });
      }
    },
    csvExport(tableData) {
      const arrData = tableData;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    csvDownload(download) {
      let bookingTableData = [];
      download.map((event, eventIndex) => {
        if (event.id) {
          bookingTableData.push({
            id: event.id,
            time: event.time,
            firstname: event.firstname,
            lastname: event.lastname,
            email: event.email,
            mobile: event.mobile,
            dob: event.dob,
            marketing: event.marketing,
            marketingEmail: event.marketingEmail,
            marketingText: event.marketingText
          });
          if (event.customData) {
            let customData = JSON.parse(event.customData);
            if (customData) {
              let key = Object.keys(customData)[0];
              bookingTableData[bookingTableData.length - 1][key] =
                customData[Object.keys(customData)[0]];
            }
          }
        }
      });
      if (bookingTableData.length > 0) {
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    csvDownloadAll(events) {
      let bookingTableData = [];
      events.forEach(function (event, eventIndex) {
        event.slot.forEach(function (slot) {
          if (slot.id) {
            bookingTableData.push({
              // id: slot.id,
              date: moment(event.date).format("DD/MM/YYYY"),
              time: slot.time,
              firstname: slot.firstname,
              lastname: slot.lastname,
              email: slot.email,
              mobile: slot.mobile,
              dob: slot.dob,
              location: event.town,
              marketing: slot.marketing,
              marketingEmail: slot.marketingEmail,
              marketingText: slot.marketingText
            });

            if (slot.customData > 0) {
              let customData = JSON.parse(slot.customData);
              let key = Object.keys(customData)[0];
              bookingTableData[bookingTableData.length - 1][key] =
                customData[Object.keys(customData)[0]];
            }
          }
        });
      });
      if (bookingTableData.length > 0) {
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    markAttendance(item) {
      API.graphql(
        graphqlOperation(mutations.updateEventBooking, {
          input: {
            id: item.id,
            attendance: item.attendance,
          },
        })
      ).then((result) => {
        const updateEventBooking = result.data.updateEventBooking;
        this.events.map((event, eventIndex) => {
          event.slot.map(async (slot, slotIndex) => {
            if (slot.id === updateEventBooking.id) {
              Object.assign(
                this.events[eventIndex].slot[slotIndex].attendance,
                updateEventBooking.attendance
              );
              if (updateEventBooking.attendance) {
                this.showSuccessMessage(
                  `${updateEventBooking.firstname} ${updateEventBooking.lastname} marked as attending`
                );
              } else {
                this.showSuccessMessage(
                  `${updateEventBooking.firstname} ${updateEventBooking.lastname} marked as NOT attending`
                );
              }
            }
          });
        });
      });
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
  },
  computed: {
    rangeOfYears() {
      const currentYear = new Date().getFullYear();
      let range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      range = range(currentYear - 15, currentYear - 90, -1);
      let dateRange = [];
      range.forEach(function (year) {
        dateRange.push({ text: year.toString(), value: year.toString() });
      });
      return dateRange;
    },
  },
};
</script>
<style scoped>
.v-input--radio-group--row {
  margin: 0;
  padding: 0;
}
.v-input--radio-group--row .v-messages.theme--light {
  border: 1px solid blue !important;
  display: none !important;
}
/* .v-input--selection-controls {
  margin-top: 4px;
  padding-top: 8px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  border:1px solid red;
} */
p {
  margin: 0;
  padding: 0;
}
</style>